var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 30.441 40.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.944,38.5v-3h-3a1.5,1.5,0,1,1,0-3h3v-3a1.5,1.5,0,1,1,3,0v3h3a1.5,1.5,0,0,1,0,3h-3v3a1.5,1.5,0,1,1-3,0Zm-7.9-.5h-12A3.045,3.045,0,0,1,0,34.959V3.039A3.044,3.044,0,0,1,3.043,0H15.484V7.6a4.278,4.278,0,0,0,4.277,4.271h9.122V24.765A10.508,10.508,0,0,0,15.039,38h0ZM22.133,6.96A1.335,1.335,0,0,1,20.8,5.624V.526a.519.519,0,0,1,.52-.52,2.257,2.257,0,0,1,1.448.52L28.13,5a2.08,2.08,0,0,1,.752,1.61.348.348,0,0,1-.352.351Z",
    fill: "#007f0e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDocument);
export default __webpack_public_path__ + "static/media/add-document.959cff5defe8b4604b0ca008339f2fc2.svg";
export { ForwardRef as ReactComponent };